export default function (props: any) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.501 3C8.2581 3 5.61536 5.60672 5.49691 8.86777L5.49276 9.09632V14.7793C5.49276 15.4119 4.61269 16.1369 4.17165 16.7289C4.08311 16.8477 4.17343 17 4.32163 17H18.6787C18.8268 17 18.919 16.8466 18.8326 16.7262C18.3888 16.1078 17.5645 15.4996 17.5093 14.7796V9.09632C17.5093 5.72938 14.8194 3 11.501 3Z"
                fill="black"
                stroke="black"
                strokeWidth="1.5"
            />
            <path d="M10 19H14C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z" fill="black" stroke="black" strokeWidth="1.5" />
        </svg>
    );
}
